import { Injectable } from '@angular/core';
import { CampPatientnotesApi } from '../api/camp-patientnotes.api';
import { CampPatientnotesData , CampPatientnotes } from '../../../interfaces/masters/camp-patientnotes';
import { Observable } from 'rxjs';

@Injectable()
export class CampPatientnotesService extends  CampPatientnotesData {

  constructor(private api: CampPatientnotesApi) { 
    super();
  }
  list(url: string): Observable<CampPatientnotes[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<CampPatientnotes>{
      return this.api.getById(url);
  }
  create(url: string, data:any): Observable<any[]> {
    return this.api.add(url,data);
  }
  searchList(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }
  update(url: string, data:CampPatientnotes): Observable<CampPatientnotes> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
